import { forwardRef } from 'react';

import * as Styled from './Carousel.styles';

const CarouselItem = forwardRef(
  ({ className, slidesPerView, gap = 24, ...props }, ref) => {
    return (
      <Styled.Item
        ref={ref}
        className={className}
        $slidesPerView={slidesPerView}
        $gap={gap}
        {...props}
      />
    );
  },
);

CarouselItem.displayName = 'CarouselItem';

export default CarouselItem;
